export default __webpack_public_path__ + "static/img/13.0179df8.png";